import React from "react";

import withAuthentication from "./firebase/withAuthentication";
import accountScope from "./utils/AccountScope";

import { Route, Switch, Redirect } from "react-router-dom";

//Components
import PageProjects from "./pages/PageProjects";
import PageClients from "./pages/PageClients";
import PageClientView from "./pages/PageClientView";
import PageReports from "./pages/PageReports";
import PageNotifications from "./pages/PageNotifications";
import PageSettings from "./pages/PageSettings";
import PageApproval from "./pages/PageApproval";
import Page404 from "./pages/Page404";
import PageLogin from "./pages/PageLogin";
import PageManageProject from "./pages/PageManageProject";
import PageManageClient from "./pages/PageManageClient";
import PageProfile from "./pages/PageProfile";
import PageUsers from "./pages/PageUsers";
import profileScope from "./utils/ProfileScope";
import PageActivities from "./pages/PageActivities";
import PageLanding from "./pages/PageLanding";

class App extends React.Component {
  render() {
    return (
      <Switch>
        <Redirect exact from="/dash/" to="/dash/notifications" />

        <Route
          exact
          path="/dash/notifications/"
          component={PageNotifications}
        />
        <Route exact path="/dash/projects" component={PageProjects} />
        <Route exact path="/dash/projects/:clientId" component={PageProjects} />
        <Route
          exact
          path="/dash/projects/:clientId/manage/:projectId"
          component={PageManageProject}
        />
        <Route exact path="/dash/clients/" component={PageClients} />
        <Route
          exact
          path="/dash/clients/:clientId"
          component={PageManageClient}
        />
        <Route exact path="/dash/reports/" component={PageReports} />

        <Route exact path="/dash/users/" component={PageUsers} />

        <Route exact path="/dash/settings/" component={PageSettings} />
        <Route exact path="/dash/client/" component={PageClientView} />
        <Route exact path="/dash/activities/" component={PageActivities} />

        <Route exact path="/profile/" component={PageProfile} />
        <Route exact path="/login/" component={PageLogin} />

        <Redirect exact from="/client/approval/" to="/client/approval/0/0" />
        <Redirect
          exact
          from="/client/approval/:killme"
          to="/client/approval/0/0"
        />
        <Route
          exact
          path="/client/approval/:approvalId/:secret"
          component={PageApproval}
        />

        <Route exact path="/" component={PageLanding} />

        <Route component={Page404} />
      </Switch>
    );
  }
}

//export default accountScope(withAuthentication(App));
export default withAuthentication(accountScope(profileScope(App)));



// WEBPACK FOOTER //
// ./src/App.js